export default [
  {
      path: "/",        
      component: () => import("../views/dashboard/Index.vue"),
      children: [
          {
              path: '',
              name: "AdminDashboard",
              component: () => import("../views/dashboard/Dashboard.vue"),
              meta: {requiresAuth: false},
          },
          {
              path: "profile",
              name: "profile",
              component:  () => import("../views/user/Profile.vue"),
          },
          {
              path: "coming-soon",
              name: "ComingSoon",
              component:  () => import("../views/ComingSoon.vue"),
          },
          {
              path: "analytics-reporting",
              name: "Analytics",
              component:  () => import("../views/analytics_reporting/Analytics.vue"),
          },
            {
            path: "analytics-reporting/breeder",
            name: "AnalyticsBreeder",
            component:  () => import("../views/analytics_reporting/AnalyticsBreeder.vue"),
            },
            {
                path: "analytics-reporting/health",
                name: "AnalyticsHealth",
                component:  () => import("../views/analytics_reporting/AnalyticsHealth.vue"),
            },
            {
                path: "analytics-reporting/datasci",
                name: "AnalyticsDatasci",
                component:  () => import("../views/analytics_reporting/AnalyticsDatasci.vue"),
            },
            {
                path: "analytics-reporting/product",
                name: "AnalyticsProduct",
                component:  () => import("../views/analytics_reporting/AnalyticsProduct.vue"),
            },
            {
                path: "analytics-reporting/semenemb",
                name: "AnalyticsSemenEmb",
                component:  () => import("../views/analytics_reporting/AnalyticsSemenEmb.vue"),
            },
            {
                path: "analytics-reporting/production",
                name: "AnalyticsProduction",
                component:  () => import("../views/analytics_reporting/AnalyticsProduction.vue"),
            },
            {
                path: "analytics-reporting/calfAnalytics",
                name: "calfAnalytics",
                component:  () => import("../views/analytics_reporting/Production-Analytics/CalfAnalytics.vue"),
            },
            {
                path: "analytics-reporting/animalAnalytics",
                name: "animalAnalytics",
                component:  () => import("../views/analytics_reporting/Production-Analytics/TotalAnimalAnalytics.vue"),
            },
            {
                path: "analytics-reporting/semenAnalytics",
                name: "semenAnalytics",
                component:  () => import("../views/analytics_reporting/HealthAnalytics/SemenAnalytics.vue"),
            },
            {
                path: "analytics-reporting/pregnancyAnalytics",
                name: "pregnancyAnalytics",
                component:  () => import("../views/analytics_reporting/HealthAnalytics/PregnancyAnalytics.vue"),
            },
          {
              path: "/action-list",
              name: "ActionList",
              component:  () => import("../views/action_list/ActionList.vue"),
          },
          {
              path: "/action-list/create-task",
              name: "CreateTask",
              component:  () => import("../views/action_list/CreateTask.vue"),
          },
          {
              path: "/action-list/daily-task",
              name: "DailyTask",
              component:  () => import("../views/action_list/DailyTask.vue"),
          },
          {
              path: "/action-list/task/:task_id",
              name: "SingleDailyTask",
              component:  () => import("../views/action_list/SingleDailyTask.vue"),
          },
          {
            path: "/action-list/updatetask/:task_id",
            name: "UpdateTask",
            component:  () => import("../views/action_list/UpdateTask.vue"),
        },
          {
              path: "/action-list/task/:task_id/record",
              name: "TaskInsemination",
              component:  () => import("../views/action_list/RecordSection.vue"),
          },
          {
              path: "/action-list/task/:task_id/health",
              name: "TaskHealthRecord",
              component:  () => import("../views/action_list/HealthRecord.vue"),
          },
          {
              path: "/genetic-search",
              name: "GeneticSearch",
              component:  () => import("../views/epd/GeneticSearchTool.vue"),
          },
          {
              path: "/search-list",
              name: "GeneticSearchList",
              component:  () => import("../views/epd/SearchGenetic.vue"),
          },
          {
              path: "/compare-genetic",
              name: "GeneticSelectedCompared",
              component:  () => import("../views/epd/SelectedCompared.vue"),
          },
            {
                path: "/genetics/edit/:geneticid",
                name: "EditGenetics",
                component:  () => import("../views/genetics/EditGenetics.vue"),
            },
            {
                path: "/genetics/edit/v2/:geneticid",
                name: "EditGeneticsV2",
                component:  () => import("../views/genetics/EditGeneticsV2.vue"),
            },
            {
                path: "/genetics/epd-info/:geneticid",
                name: "SingleAnimalEpd",
                component:  () => import("../views/genetics/SingleAnimalEpd.vue"),
            },
            {
                path: "user-guide",
                name: "UserGuide",
                component:  () => import("../views/genetics/UserGuide.vue"),
            },
            {
                path: "/genetics",
                component:  () => import("../views/genetics/Genetics.vue"),
                name: "Genetics",
                redirect: { name: 'GeneticsList'},
                children: [
                    {
                        path: "list",
                        name: "GeneticsList",
                        component:  () => import("../views/genetics/GeneticsList.vue"),
                    },
                    {
                        path: "v2/list",
                        name: "GeneticsListV2",
                        component:  () => import("../views/genetics/GeneticsListV2.vue"),
                    },
                    {
                        path: "grid",
                        name: "GeneticsGrid",
                        component:  () => import("../views/genetics/GeneticsGrid.vue"),
                    },
                    
                ]
            },
            {
                path: "/genetics/manage-animal-group",
                name: "ManageAnimalsGroup",
                component: () => import("../views/genetics/ManageAnimalsGroup"),
            },
            {
                path: "genetics/modelSettings",
                name: "modelSettings",
                component:  () => import("../views/genetics/EPDModelSettings.vue"),
            },
            {
                path: "genetics/cgReports",
                name: "cgReports",
                component: () => import("../views/genetics/ContemporaryGroupReports.vue"),
            },
            {
                path: "genetics/cgDetail/:groupCode",
                name: "cgDetail",
                component: () => import("../views/genetics/ContemporaryGroupDetail.vue")
            },
            {
                path: "genetics/bulkUploadStatus",
                name: "bulkUploadStatus",
                component: () => import("../views/genetics/BulkUploadStatus.vue"),
            },
            {
                path: "genetics/requiredFieldsSetting",
                name: "requiredFieldsSetting",
                component:  () => import("../views/genetics/EPDRequiredFieldsSetting.vue"),
            },
            {
                path: "genetics/contemporaryGroups",
                name: "contemporaryGroups",
                component:  () => import("../views/genetics/contemporary-groups/Index.vue"),
            },
            {
                path: "genetics/contemporaryGroup/add",
                name: "addContemporaryGroup",
                component:  () => import("../views/genetics/contemporary-groups/Add.vue"),
            },
            {
                path: "genetics/contemporaryGroup/edit/:trait/:id",
                name: "editContemporaryGroup",
                component:  () => import("../views/genetics/contemporary-groups/Edit.vue"),
            },
            {
                path: "genetics/v2/data-submission",
                name: "GeneticsDataSubmission",
                component:  () => import("../views/genetics/GeneticsDataSubmission.vue"),
            },
            {
                path: "genetics/data-submission",
                name: "GeneticsDataSubmissionV1",
                component:  () => import("../views/genetics/GeneticsDataSubmissionV1.vue"),
            }
      ]
  },
  {
      path: '/users',
      component: () => import("../views/user/Index.vue"),
      children: [
          {
              path: '',
              name: 'Users',
              component: () => import("../views/user/UserList.vue")
          },
          {
            path: '/activitylog',
            name: 'ActivityLog',
            component: () => import("../views/activitylog/ActivityLog.vue")
        }
      ]
  },
  {
      path: '/roles',
      component: () => import("../views/roles/Index.vue"),
      children: [
          {
              path: ':department?',
              name: 'Roles',
              component: () => import("../views/roles/RoleList.vue")
          },
          {
              path: 'permissions/:department?/:role_number?',
              name: 'Permissions',
              component: () => import("../views/roles/Permissions.vue")
          }
      ]
  },
  {
      path: '/departments',
      component: () => import("../views/roles/Index.vue"),
      children: [
          {
              path: '',
              name: 'Departments',
              component: () => import("../views/roles/DepartmentList.vue")
          }
      ]
  },
  {
      path: '/myfarm',
      component: () => import("../views/my_farm/Index.vue"),
      children: [
          {
              path: '',
              name: 'My farm',
              component: () => import("../views/my_farm/FarmList.vue")
          },
          {
              path: 'farmregistration',
              name: 'FarmRegistartion',
              component: () => import("../views/my_farm/FarmRegistration.vue")
          },
          {
              path: ':id',
              name: 'SingleFarm',
              component: () => import("../views/my_farm/Singlefarm.vue")
          },
          {
              path: 'editfarm/:id',
              name: 'EditFarm',
              component: () => import("../views/my_farm/EditFarm.vue")
          },
            {
                path: 'assignusers/:id',
                name: 'AssignUsersFarm',
                component: () => import("../views/my_farm/UserAssignmentFarm.vue")
            },
          {
              path: '/googlemap',
              name: 'GoogleMap',
              component: () => import("../views/my_farm/GoogleMap.vue")
          },
      ]
  },
  {
      path: '/drugList',
      component: () => import("../views/drug/Index.vue"),
      children: [
          {
              path: '',
              name: 'DrugList',
              component: () => import("../views/drug/DrugList.vue")
          },
          {
              path: 'drugregister',
              name: 'DrugRegister',
              component: () => import("../views/drug/Drugregister.vue")
          },
          {
              path: ':id',
              name: 'DrugInventory',
              component: () => import("../views/drug/druginventory.vue")
          },
          {
              path: 'editDrug/:id',
              name: 'EditDrug',
              component: () => import("../views/drug/DrugUpdate.vue")
          },
      ]
  },
  {
      path: '/animals',
      component: () => import("../views/animals/Index.vue"),
      children: [
          {
              path: '',
              name: 'Animals',
              component: () => import("../views/animals/Animals.vue")
          },
          {
              path: "add-animal",
              name: "AddAnimal",
              component: () => import("../views/animals/AddAnimal.vue")
          },
          {
              path: "add-animal/success/:animal_number",
              name: "AddAnimalSuccess",
              component: () => import("../views/animals/AddAnimalSuccess.vue")
          },
          {
              path: "add-animal/farm/:farm_number",
              name: "AddFarmAnimal",
              component: () => import("../views/animals/AddAnimal.vue"),
          },
          {
              path: ":animal_number",
              component: () => import("../views/animals/AnimalDetails.vue"),
              children: [
                  {
                      path: 'details',
                      component: () => import("../views/animals/GeneralInfo.vue"),
                      name: "AnimalDetails",
                  },
                  {
                      path: 'performance',
                      component: () => import("../views/animals/PerformanceInfo.vue"),
                      name: "AnimalPerformance",
                  },
                  {
                      path: 'performance/edit',
                      component: () => import("../views/animals/performance/PerformanceEdit.vue"),
                      name: "AnimalPerformanceEdit",
                  },
                  {
                    path: 'feed',
                    component: () => import("../views/animals/FeedInfo.vue"),
                    name: "AnimalFeedInfo",
                  },
                  {
                    path: 'feed/edit',
                    component: () => import("../views/animals/feed/FeedInfoEdit.vue"),
                    name: "AnimalFeedInfoEdit",
                  },
                  {
                      path: 'genetic-worth',
                      component: () => import("../views/animals/GeneticWorthInfo.vue"),
                      name: "AnimalGeneticWorth",
                  },
                  {
                      path: 'genetic-worth/edit',
                      component: () => import("../views/animals/geneticworth/GenWorthEdit.vue"),
                      name: "AnimalGenWorthEdit",
                  },
                  {
                      path: 'conception/edit',
                      component: () => import("../views/animals/conception/ConceptionEdit.vue"),
                      name: "AnimalConceptionEdit",
                  },
                  {
                      path: 'conception',
                      component: () => import("../views/animals/ConceptionInfo.vue"),
                      name: "AnimalConception",
                  },
                  {
                      path: 'health-record',
                      component: () => import("../views/animals/HealthRecord.vue"),
                      name: "AnimalHealthReord",
                  },
                  {
                      path: 'health-record/edit',
                      component: () => import("../views/animals/healthrecord/HealthRecordEdit.vue"),
                      name: "AnimalHealthReordEdit",
                  },
                  {
                      path: 'gene-data',
                      component: () => import("../views/animals/GeneData.vue"),
                      name: "AnimalGeneData",
                  },
                  {
                      path: 'gene-data/edit',
                      component: () => import("../views/animals/genedata/GeneDataEdit.vue"),
                      name: "GeneDataEdit",
                  },
                  {
                      path: 'reminders',
                      component: () => import("../views/animals/Reminders.vue"),
                      name: "AnimalReminders",
                  },
                  {
                      path: 'activity-log',
                      component: () => import("../views/animals/ActivityLog.vue"),
                      name: "AnimalActivityLog",
                  },
                  {
                      path: 'notes',
                      component: () => import("../views/animals/Notes.vue"),
                      name: "AnimalNotes",
                  },
              ],
              
          },
          {
              path: ':animal_number/edit',
              component: () => import("../views/animals/EditAnimal.vue"),
              name: "EditAnimal",
          }
      ]
  },
  {
      path: '/geneList',
      component: () => import("../views/gene/Index.vue"),
      children: [
          {
              path: '',
              name: 'GeneList',
              component: () => import("../views/gene/GeneList.vue")
          },
          {
              path: 'geneReg',
              name: 'GeneRegistration',
              component: () => import("../views/gene/GeneRegister.vue")
          },
          {
              path: 'gene/:id',
              name: 'GeneDetails',
              component: () => import("../views/gene/GeneDetails.vue")
          },
      ]
  },
  {
      path: '/genoList',
      component: () => import("../views/genoperformance/Index.vue"),
      children: [
          {
              path: '',
              name: 'GenoList',
              component: () => import("../views/genoperformance/PerformanceList.vue")
          },
          {
              path: 'genoReg',
              name: 'GenoRegistration',
              component: () => import("../views/genoperformance/GenoTypeRegister.vue")
          },
          {
              path: 'geno/:id',
              name: 'GenoTypeView',
              component: () => import("../views/genoperformance/GenoTypeView.vue")
          },
          {
              path: 'editGeno/:id',
              name: 'GenoTypeEdit',
              component: () => import("../views/genoperformance/GenoTypeEdit.vue")
          },
      ]
  },
  {
      path: '/ntrorg',
      component: () => import("../views/ntr/Index.vue"),
      children: [
          {
              path: '',
              name: 'ProductList',
              component: () => import("../views/ntr/ProductList.vue")
          },
          {
              path: 'farmProducts/:farmId',
              name: 'FarmProducts',
              component: () => import("../views/ntr/FarmProducts.vue")
          },
          {
              path: ':farmId/:productId',
              name: 'SingleProduct',
              component: () => import("../views/ntr/SingleProduct.vue")
          },
          {
              path: 'addProduct/:farmId',
              name: 'AddFarmProduct',
              component: () => import("../views/ntr/RegisterProduct.vue")
          },
          {
              path: 'createOrder/:farmId/:productId',
              name: 'CreateOrder',
              component: () => import("../views/ntr/CreateOrder.vue")
          },
          {
              path: 'orderDetails/:orderId',
              name: 'OrderDetails',
              component: () => import("../views/ntr/OrderDetails.vue")
          },
      ]
  },
  {
      path: '/semen-automation',
      component: () => import("../views/semen/Index.vue"),
      children: [
          {
              path: '',
              name: 'SemenAuto',
              component: () => import("../views/semen/SemenAutoList.vue")
          },
          {
              path: "register/sire",
              name: "AddSire",
              component: () => import("../views/semen/SemenRegister/Sire.vue")
          },
          {
              path: "register/approval",
              name: "AddApproval",
              component: () => import("../views/semen/SemenRegister/Approval.vue")
          },
          {
              path: "register/collection",
              name: "AddCollection",
              component: () => import("../views/semen/SemenRegister/Collection.vue")
          },
          {
              path: "register/postage",
              name: "AddPostage",
              component: () => import("../views/semen/SemenRegister/Postage.vue")
          },
          {
              path: "register/pack",
              name: "AddPack",
              component: () => import("../views/semen/SemenRegister/Pack.vue")
          },
          {
              path: "register/straws",
              name: "AddStraws",
              component: () => import("../views/semen/SemenRegister/Straws.vue")
          },
          {
              path: "editSire/:id",
              name: "EditSire",
              component: () => import("../views/semen/editSemen/SireEdit.vue")
          },
          {
              path: "editApproval/:id",
              name: "EditApproval",
              component: () => import("../views/semen/editSemen/ApprovalEdit.vue")
          },
          {
              path: "editColl/:id",
              name: "EditCollection",
              component: () => import("../views/semen/editSemen/CollectionEdit.vue")
          },
          {
              path: "editPostage/:id",
              name: "EditPostage",
              component: () => import("../views/semen/editSemen/PostageEdit.vue")
          },
          {
              path: "editPack/:id",
              name: "EditPack",
              component: () => import("../views/semen/editSemen/PackEdit.vue")
          },
          {
              path: "editStraw/:id",
              name: "StrawsEdit",
              component: () => import("../views/semen/editSemen/StrawsEdit.vue")
          },
      ]
  },
  {
      path: '/inseminatorsection',
      component: () => import("../views/semen/Index.vue"),
      children: [
          {
              path: '',
              name: 'InseminatorList',
              component: () => import("../views/inseminator/InseminatorList.vue")
          },
          {
              path: "register/inseminator",
              name: "AddInsemi",
              component: () => import("../views/inseminator/InsemiStaticsRegister.vue")
          },
          {
              path: ":id",
              name: "SingleInsemi",
              component: () => import("../views/inseminator/SingleInseminator.vue")
          },
          {
              path: "edit/:id",
              name: "EditInsemi",
              component: () => import("../views/inseminator/EditInseminator.vue")
          }, 
      ]
  }
];